import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService, SharedGenericSingletonService, SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { ICustomerGenericService, ICustomerTeltonikaService, IHIPGenericService, IHIPTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { TeltonikaConfirmUploadModalComponent } from '../teltonika-confirm-upload-modal/teltonika-confirm-upload-modal.component';
import { DirectivesModule, MaterialModule } from '@huge-monorepo/shared/modules';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '@huge-monorepo/hip/tools';
import { YesNoModalComponent } from '@huge-monorepo/shared/tools';

@Component({
  selector: 'huge-monorepo-teltonika-upload-firmware',
  standalone: true,
  imports: [CommonModule, MaterialModule, DirectivesModule],
  templateUrl: './teltonika-upload-firmware.component.html',
  styleUrl: './teltonika-upload-firmware.component.scss',
})
export class TeltonikaUploadFirmwareComponent {
  firmwareFiles: FileList | null = null;
  isFirmwareFileUploaded: boolean = false;
  firmwareWorking: boolean = false;
  confirmed: boolean = false;

  genericService: IHIPGenericService = this.genericServiceSingleton.getGenericService();
  teltonikaService: IHIPTeltonikaService = this.teltonikaServiceSingleton.getService();

  constructor(
    private genericServiceSingleton: SharedGenericSingletonService<IHIPGenericService>,
    private teltonikaServiceSingleton: SharedTeltonikaSingletonService<IHIPTeltonikaService>,
    private dialog: MatDialog,
    private dialogService: DialogService,
  ) {}

  handleFirmwareDroppedFiles(files) {
    let input = document.getElementById('firmwareFileInput') as HTMLInputElement;
    if (input != null) {
      this.onFirmwareFileInput(files);
    }
  }

  onFirmwareFileInput(files: FileList | null) {
    if (files == null || files.length === 0) {
      this.genericService.createToast('Error', 'Please select a file to upload', 'error');
      return;
    }
    if (this.firmwareWorking) {
      this.genericService.createToast('Busy Uploading', 'You cannot change the file list whilst uploading. Please wait for the current process to finish', 'error');
      return;
    }

    if (files.length === 1) {
      if (!files[0].name.endsWith('.bin')) {
        this.genericService.createToast('Error', 'Please select a .bin file', 'error');
        return;
      }
      this.firmwareFiles = files;
      this.isFirmwareFileUploaded = true;
      return;
    } else {
      this.genericService.createToast('Error', 'Please select only one file', 'error');
      return;
    }
  }

  deleteFirmwareFile() {
    this.firmwareFiles = null;
    this.isFirmwareFileUploaded = false;
  }

  uploadFirmware() {
    if (this.firmwareWorking) {
      this.genericService.createToast('Busy Uploading', 'You cannot change the file list whilst uploading. Please wait for the current process to finish', 'error');
      return;
    }
    if (this.firmwareFiles == null || this.firmwareFiles.length === 0) {
      this.genericService.createToast('Error', 'Please select a file to upload', 'error');
      return;
    } else if (!this.confirmed) {
      this.genericService.createToast('Error', 'Please confirm that the config has been tested and is working correctly', 'error');
      return;
    }

    const dialogRef = this.dialog.open(YesNoModalComponent, {
      maxHeight: '60vh',
      data: { Message: `Are you sure you would like to upload ${this.firmwareFiles[0].name}` },
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result !== null) {
        if (result != false) {
          this.firmwareWorking = true;
          if (this.firmwareFiles != null) {
            this.teltonikaService.uploadTeltonikaDeviceFirmware(this.firmwareFiles).subscribe({
              next: (resp) => {
                this.genericService.createToast('Uploaded', 'File uploaded successfully', 'success');
                this.firmwareWorking = false;
              },
              error: (err) => {
                this.genericService.createToast('Error Uploading', 'There was an error Uploading your file', 'error');
                console.error(err);
                this.firmwareWorking = false;
              },
            });
          }
        }
      }
    });
    return;
  }
}
